"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ExternalReportHeaders () {
        return ExternalReportHeaders;
    },
    get ExternalReportParams () {
        return ExternalReportParams;
    },
    get GetReviewReportByIdParams () {
        return GetReviewReportByIdParams;
    },
    get GetReviewReportsParams () {
        return GetReviewReportsParams;
    },
    get GetReviewsQuerystring () {
        return GetReviewsQuerystring;
    },
    get PatchReviewReportBody () {
        return PatchReviewReportBody;
    },
    get PatchReviewReportExternalAuthorByIdBody () {
        return PatchReviewReportExternalAuthorByIdBody;
    },
    get PostReviewBody () {
        return PostReviewBody;
    },
    get PostReviewReportBody () {
        return PostReviewReportBody;
    },
    get PostReviewReportsParams () {
        return PostReviewReportsParams;
    },
    get PutReviewByIdBody () {
        return PutReviewByIdBody;
    },
    get PutReviewReportAnswersByIdBody () {
        return PutReviewReportAnswersByIdBody;
    },
    get ReviewIdParams () {
        return ReviewIdParams;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _formassignment = require("./form-assignment");
const _reviewreport = require("./review-report");
const GetReviewReportsParams = _zod.z.object({
    reviewId: _utilsisomorphic.transformObjectId
});
const GetReviewReportByIdParams = _zod.z.object({
    reportId: _utilsisomorphic.transformObjectId
});
const ExternalReportParams = _zod.z.object({
    reportId: _utilsisomorphic.transformObjectId
});
const ExternalReportHeaders = _zod.z.object({
    authorization: _zod.z.string().min(1)
});
const PostReviewReportsParams = _zod.z.object({
    reviewId: _utilsisomorphic.transformObjectId
});
const PostReviewReportBodyBase = _zod.z.object({
    reviewFormId: _reviewreport.BaseReviewReportWithoutContent.shape.reviewFormId,
    redacted: _reviewreport.BaseReviewReportWithoutContent.shape.redacted.optional().default(false),
    visibleAfterCompletion: _reviewreport.BaseReviewReportWithoutContent.shape.visible.optional().default(false)
});
const PostReviewReportStandardBody = PostReviewReportBodyBase.extend(_reviewreport.ReviewReportStandardWithoutContent.pick({
    authorsDueDate: true,
    signersDueDate: true
}).shape).extend({
    reviewReportType: _zod.z.literal("standard"),
    authors: _zod.z.array(_models.ReviewAssignmentAuthor),
    signers: _zod.z.array(_models.ReviewAssignmentSigner),
    reviewReportPerAuthor: _zod.z.boolean().optional()
});
const PostReviewReportExternalAuthorInput = _zod.z.object({
    name: _formassignment.ExternalAuthorInput.shape.name.nullable(),
    email: _formassignment.ExternalAuthorInput.shape.email.nullable(),
    message: _formassignment.ExternalAuthorInput.shape.emailBody.nullable()
});
const PostReviewReportExternalBody = PostReviewReportBodyBase.extend({
    authors: PostReviewReportExternalAuthorInput.array().max(1),
    // Explicitly reject fields that belong to standard reports, not external
    authorsDueDate: _zod.z.undefined({
        message: "Author due date is not allowed in external reports"
    }).optional(),
    signersDueDate: _zod.z.undefined({
        message: "Signer due date is not allowed in external reports"
    }).optional(),
    signers: _zod.z.undefined({
        message: "Signers are not allowed in external reports"
    }).optional()
}).extend({
    reviewReportType: _zod.z.literal("external")
});
const PostReviewReportEasyAddBody = _reviewreport.ReviewReportEasyAddWithoutContent.pick({
    easyAddComment: true,
    easyAddConfigId: true
}).extend({
    reviewReportType: _zod.z.literal("easy-add"),
    /**
	 * Some easy add configs allow specifying authors, otherwise uses "self"
	 */ authors: _zod.z.array(_utilsisomorphic.transformObjectId).optional()
});
const PostReviewReportBody = _zod.z.discriminatedUnion("reviewReportType", [
    PostReviewReportStandardBody,
    PostReviewReportExternalBody,
    PostReviewReportEasyAddBody
]);
const PatchReviewReportBody = _zod.z.object({
    visible: _zod.z.boolean().optional(),
    redacted: _zod.z.boolean().optional(),
    authorsDueDate: _reviewreport.BaseReviewReportWithoutContent.shape.authorsDueDate.optional(),
    signersDueDate: _reviewreport.BaseReviewReportWithoutContent.shape.signersDueDate.optional(),
    authors: _zod.z.array(_models.ReviewAssignmentSingularParticipant).optional(),
    signers: _zod.z.array(_models.ReviewAssignmentSigner).optional(),
    /**
	 * The base_id of the review form to update to.
	 * Only allowed for external review reports when the invite has not been sent.
	 * Resolves to the latest form version.
	 */ reviewFormBaseId: _utilsisomorphic.transformObjectId.optional()
});
const GetReviewsQuerystring = _zod.z.object({
    status: _zod.z.enum([
        "active",
        "completed",
        "closed",
        "scheduled"
    ]).optional(),
    subject: _utilsisomorphic.transformObjectId.optional(),
    subjectManager: _utilsisomorphic.transformObjectId.optional(),
    easyAddStatus: _zod.z.enum([
        "awaitingApproval",
        "easyAddEnabled"
    ]).optional(),
    sortName: _zod.z.enum([
        "name",
        "startDate"
    ]).optional().default("name"),
    sortDirection: _zod.z.enum([
        "asc",
        "desc"
    ]).optional().default("asc"),
    skip: _zod.z.string().optional().default("0").transform((val)=>parseInt(val, 10)).pipe(_zod.z.number().int().min(0)),
    limit: _zod.z.string().optional().default("50").transform((val)=>parseInt(val, 10)).pipe(_zod.z.number().int().min(1).max(50))
});
const ReviewIdParams = GetReviewReportsParams;
const PostReviewBody = _zod.z.object({
    name: _zod.z.string().min(1).max(280),
    subjectId: _utilsisomorphic.transformObjectId,
    startDate: _zod.z.coerce.date(),
    workflowId: _utilsisomorphic.transformObjectId.optional(),
    adminsOnly: _zod.z.boolean().optional().default(false),
    forms: _zod.z.array(_formassignment.DirectFormAssignmentInput).max(100).optional().default([])
});
const PutReviewByIdBody = _zod.z.object({
    name: _zod.z.string().min(1).max(280).optional(),
    adminsOnly: _zod.z.boolean().optional(),
    startDate: _zod.z.coerce.date().optional()
}).refine((body)=>body.name !== undefined || body.adminsOnly !== undefined || body.startDate !== undefined, {
    message: "At least one field (name, adminsOnly, startDate) must be provided"
});
const PutReviewReportAnswersByIdBody = _zod.z.object({
    answers: (0, _utilsisomorphic.toCamelCaseSchema)(_models.ReviewReportModel.shape.answers)
});
const PatchReviewReportExternalAuthorByIdBody = _reviewreport.ReviewReportExternalAuthor.pick({
    name: true,
    email: true,
    message: true
}).partial().refine((data)=>!data.email || _zod.z.string().email().safeParse(data.email).success, {
    message: "Invalid email format",
    path: [
        "email"
    ]
});
